export const SEARCH_ITEM_CONTENT_HEIGHT = 60;
